<div class="login-wrapper">
  <div class="backdrop-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container">
      <div *ngIf="appContext.isSunip">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="SunIP"/>
      </div>
      <div *ngIf="appContext.isForecaster">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="ChiefIP"/>
      </div>
      <div *ngIf="appContext.isLegalsight">
        <img src="{{appContext.fullLogoColor}}" style="height: 70px" title="LegalSight"/>
      </div>

      <form class="margin-top-30" *ngIf="!showText; else showSubmitted" [formGroup]="form" novalidate>
        <h4 class="card-title text-bold">Reset Password</h4>
        <p>
          Please enter your email address and we'll email you a link to reset your password.
        </p>
        <div class="form-row margin-top-30">
          <townip-input class="col-md-12">
            <label>Email</label>
            <input type="text" class="form-control" formControlName="email">
            <townip-standard-alert *ngIf="errorMessage" class="mt-2" type="danger" mode="lite">
              <div class="invalid-feedback" *ngIf="errorMessage !== 'EMAIL_NOT_FOUND' else emailNotFound">
                {{errorMessage}}
              </div>
              <ng-template #emailNotFound>The user does not exist or is an offline user.</ng-template>
            </townip-standard-alert>
          </townip-input>
        </div>
        <div class="margin-top-30">
          <!-- Redirecting to logout to make sure we cleanup any session that the user has -->
          <button *ngIf="cancelEnabled" type="button" class="btn btn-secondary btn-lg" [routerLink]="['/auth/logout']">Cancel</button>
          <button [disabled]="form.invalid || loading" type="button" class="btn btn-primary btn-lg ml-1"
            (click)="resetPassword()">
            <i *ngIf="loading" class="fa fa-spin fa-refresh"></i>
            Submit
          </button>
        </div>
      </form>
      <ng-template #showSubmitted>
        <townip-standard-alert
          class="margin-top-30"
          type="success"
          mode="lite"
          iconAlignment="top">
          <p>We've sent a password reset e-mail to {{emailText}}</p>
          <p class="m-0">Please check your email and follow the instructions to reset your password. Once done,
            click here to login!
          </p>
        </townip-standard-alert>
        <button type="button" class="btn btn-primary btn-lg margin-top-30" [routerLink]="['/auth/login']">Login</button>
      </ng-template>
    </div>
  </div>
</div>
